import React from "react";

const NoDataDisplay = () => (
  <div className="flex items-center justify-center w-full h-full min-h-[200px]">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 200"
      className="w-full max-w-[200px]"
    >
      <circle cx="150" cy="100" r="80" fill="#f5f5f5" opacity="0.3" />
      <circle cx="150" cy="100" r="60" fill="#f8f8f8" opacity="0.4" />

      <g transform="translate(114, 50)">
        <rect
          x="0"
          y="40"
          width="12"
          height="30"
          fill="#20B2AA"
          opacity="0.6"
          rx="2"
        />
        <rect
          x="20"
          y="30"
          width="12"
          height="40"
          fill="#20B2AA"
          opacity="0.7"
          rx="2"
        />
        <rect
          x="40"
          y="20"
          width="12"
          height="50"
          fill="#20B2AA"
          opacity="0.8"
          rx="2"
        />
        <rect
          x="60"
          y="35"
          width="12"
          height="35"
          fill="#20B2AA"
          opacity="0.6"
          rx="2"
        />
      </g>

      <text
        x="150"
        y="145"
        fontFamily="Arial, sans-serif"
        fontSize="16"
        fill="#444"
        textAnchor="middle"
        fontWeight="bold"
      >
        No Latest Data
      </text>
      <text
        x="150"
        y="165"
        fontFamily="Arial, sans-serif"
        fontSize="8"
        fill="#666"
        textAnchor="middle"
      >
        Please check back later
      </text>
    </svg>
  </div>
);

export default NoDataDisplay;
